@if (concentDetails; as item) {
  <section class="col-xs-12 col-sm-12 myprofile_consentsection myprofile_consentsectionUS no-padding">
    <div class="myprofile_consentcontainer">
      <div class="myprofile_consentheader col-md-9 col-xs-8 no-padding">{{"consent.title" | cxTranslate}}</div>
      <div class="col-md-3 col-xs-4" (click)="edit()">
        @if (!toggleEdit) {
          <div class="myprofileconsent_editbtn" id="myprofileconsent_editbtn">{{"profile.editlabel" | cxTranslate}}<img src="/assets/images/edit.png"  width="20" alt="Edit"></div>
        }
      </div>
      <div class="clearboth"></div>
      <div class="myprofile_consentcontent">{{"consent.consenttext" | cxTranslate}}</div>
      @if (!toggleEdit) {
        <div class="myprofile_radiocontainer myprofile_radiocontainerView">
          <label class="myprofile_radio">
            <input type="radio" name="myprofile_radiobtn" class="myprofile_radiobtn" id="myprofile_radiobtn" checked="checked">
            <span class="myprofile_radiobtncontrol consent_radiobtncontrol"></span>
            <label for="myprofile_radiobtn1" class="myprofile_radioText">
            {{!item?.isConsentGranted?("consent.nolabel" | cxTranslate):("consent.yeslabel" | cxTranslate)}}</label>
          </label>
        </div>
      }
      @if (toggleEdit) {
        <div class="myprofile_editcontainer">
          <div class="myprofile_radiocontainer myprofile_radiocontaineryes">
            <label class="myprofile_radio">
              <input (click)="getValue(true)" [checked]="item?.isConsentGranted" type="radio" name="consent_radiobtn" class="myprofile_radiobtn myprofile_consentRadiobtn" id="myprofile_radiobtn1" value="true">
              <span class="myprofile_radiobtncontrol consent_radiobtncontrol"></span>
              <label for="myprofile_radiobtn1">{{"consent.yeslabel" | cxTranslate}}</label>
            </label>
          </div>
          <div class="myprofile_radiocontainer myprofile_radiocontainerno">
            <label class="myprofile_radio">
              <input (click)="getValue(false)" [checked]="!item?.isConsentGranted" type="radio" name="consent_radiobtn" class="myprofile_radiobtn myprofile_consentRadiobtn" id="myprofile_radiobtn2" value="false">
              <span class="myprofile_radiobtncontrol consent_radiobtncontrol"></span>
              <label for="myprofile_radiobtn2">{{"consent.nolabel" | cxTranslate}}</label>
            </label>
          </div>
          <button type="button" class="consentupdatebtn" (click)="edit()">{{"profile.cancellabel" | cxTranslate}}</button>
          <button type="submit" id ="myprofile_submit" class="consentupdatebtn submit_consent" (click)="submitConcent()">{{"profile.submitlabel" | cxTranslate}}</button>
        </div>
      }
    </div>
  </section>
}